<template>



          <v-container>
            <v-row>
              <v-col>
                <IntroText
                  :intro-one="pageItem.ShortText"
                  :pageItem="pageItem"
                  :showForm =false
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <v-row>
                  <v-col
                    v-for="(contact, i) in siteSettings.StokvisLocation"
                    :key="i"
                    cols="6"
                    sm="12"
                    md="6"
                  >
                    <v-row class="pa-0">
                      <v-col lass="d-flex flex-column pa-0">
                        <h2 class="pb-1">{{ contact.LocationName }}</h2>

                        <a
                          :href="contact.GoogleUrl"
                          class="text-none text-decoration-none"
                        >
                          <p class="pb-0">{{ contact.StreetHouseNumber }}</p>
                          <p class="pt-1 pb-2">{{ contact.ZipcodeCity }}</p>
                          <p class="pt-1 pb-2">{{ contact.Country }}</p>
                        </a>

                        <a
                          v-if="contact.Email"
                          :href="'mailto:' + contact.Email"
                          class="text-none text-decoration-none"
                        >
                          <p class="pb-0">
                            <SvgIconPublic class="mr-1" :url="siteSettings.IconMail" :sizeIcon="25"/>

                            {{ contact.Email }}
                          </p>
                        </a>

                        <v-sheet>
                          <a 
                            v-if="contact.Telephone"
                            footerlinks
                            :href="'tel:' + contact.Telephone"
                            class="text-none text-decoration-none"
                          >
                            <p class="pt-1">

                              <SvgIconPublic class="mr-1" :url="siteSettings.IconTelephone" :sizeIcon="25"/>
                              {{ contact.Telephone }}
                            </p>
                          </a>
                        </v-sheet>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6">
                <JSONForm v-if="pageItem.formData" :formData="pageItem.formData" />
              </v-col>
            </v-row>
          </v-container>

          <GoogleMaps/>
          
          <IntroText
            :intro-one="pageItem.MainText"
            :pageItem="pageItem"
            :showForm=false
          />
  
</template>
<style scoped>
.current-day {
  font-weight: bold;
}
</style>
<script setup>
import IntroText from "@/components/Base/introText.vue";
import HeaderOne from "@/components/Base/headerOne.vue";
import JSONForm from '@/components/JSONForm/form.vue'
import SvgIconPublic from "@/components/Base/SvgIconPublic.vue";
import GoogleMaps from "@/components/Contact/googleMaps.vue";
import { useSiteSettingsStore } from "../../store/siteSettings";
const siteSettings = useSiteSettingsStore();

const props = defineProps({
  pageItem: {
    type: Object,
    default: "",
  },
});

// Gebruik
const holidays = computed(() => {
  return sortOnDate(siteSettings.Holidays);
});

const openingTimes = computed(() => {
  return sortOnDate(siteSettings.OpeningTime);
});
function isCurrentDate(date) {

  const today = new Date();
  const dateToday = `${today.getDate().toString().padStart(2, '0')}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getFullYear()}`;
  return date === dateToday;
}

function isCurrentDay(index) {
      const today = (new Date().getDay() + 6) % 7; // sunday => 6, monday => 0
      return index === today;
}

</script>
